import { AppointmentConfiguration, AppointmentConfigurationQuery } from '@dreryk/egabinet-appointment-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

type OverlappingAppointmentsConfigurationFormRenderProps = {
   appointmentConfiguration: AppointmentConfiguration;
};

type OverlappingAppointmentsConfigurationFormLoaderProps = {
   readonly children: (renderProps: OverlappingAppointmentsConfigurationFormRenderProps) => JSX.Element;
};

export const OverlappingAppointmentsConfigurationFormLoader = (
   props: OverlappingAppointmentsConfigurationFormLoaderProps
): JSX.Element => {
   const {
      data: appointmentConfiguration,
      loading: appointmentConfigurationLoading,
      error: appointmentConfigurationError,
   } = useCqrsGet<AppointmentConfiguration>(() => new AppointmentConfigurationQuery());

   if (appointmentConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (appointmentConfigurationError) {
      return (
         <Message
            testId={'appointmentConfigurationFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      appointmentConfiguration: appointmentConfiguration,
   });
};
